module.exports = "/images/ph.svg?e51847af1a84c6ac7c3496b9356d1760";